import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="inspections/company-pending-project"
    columnLabelsDictionary={{ 
      includeInNwccproject: "Include In Inspection Company Project", 
      nwccfileType: "Inspection Company File Type", 
      loanNumber: "Loan #", 
      readyForNwcc: "Ready For Work Inspection"
    }}
    skipClick
  />;
};

const LmsInspectionsInspectionCompanyPendingProjects = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }
  return (<MainTable />);
};

export default LmsInspectionsInspectionCompanyPendingProjects;